import React, {Component} from "react";
import TreeView from "./TreeView";
import { strings } from "../localization";
import { TAG_TYPES, TAG_USER_ROLES, TAG_USER_TYPES } from "../data/tags";
import TagTypesDropDown from "./TagTypesDropDown";

export default class TagsTreeView extends Component{

    state = {
        selectedTagTypes: []
    }

    createConfirmMessage = (tagId) => {
        const tag = this.props.tags.find(tag => tag.tagId === tagId);
        const isLastTag = this.props.showLastTagWarning === true;

        return (<>
            <h4>{strings.tags_unassign_tag_confirm_title}</h4>
            <p>{strings.formatString(strings.tags_unassign_tag_confirm_message, tag.name, this.props.resource)}</p>
            {(isLastTag && this.props.lastTagWarning) && <p className='warning-message last-tag-warning'><i className='material-icons'>warning</i> {this.props.lastTagWarning}</p>}
        </>);
    }

    getReadonlyTagsIds = () => {
        const readOnlyTagsIds = [];

        if(!this.props.tags) return readOnlyTagsIds;

        if(this.props.isCurrentUser) {
            const allTagsIds = this.props.tags.map(tag => tag.tagId);
            readOnlyTagsIds.push(...allTagsIds);
            return readOnlyTagsIds;
        }

        if(this.props.disableGuestTags){
            const guestTagsIds = this.props.tags.filter(tag => !tag.canEdit).map(tag => tag.tagId);
            readOnlyTagsIds.push(...guestTagsIds);
        } 

        if(this.props.disableRootTag){
            const rootTagsIds = this.props.tags.filter(tag => !tag.parentTagId || tag.isRootTag).map(tag => tag.tagId);
            readOnlyTagsIds.push(...rootTagsIds);
        }

        if(this.props.disableInheritedTags){
            const inheritedTagsIds = this.props.inheritedTagsIds;
            readOnlyTagsIds.push(...inheritedTagsIds);
        }

        return readOnlyTagsIds;
    }

    getCustomFilter = () => {
        if(this.props.hideFilterByType) return null;
        
        const includeSystemType = this.props.tags ? this.props.tags.some(tag => tag.type === TAG_TYPES.SYSTEM) : false;

        return <TagTypesDropDown 
                    includeSystemType={includeSystemType}
                    selectedItems={this.state.selectedTagTypes}
                    onChange={(selectedItems) => {
                        this.setState({selectedTagTypes: selectedItems});
                        if(this.props.onTypeFilterChange) this.props.onTypeFilterChange(selectedItems);
                    }}
                    multipleSelection={true}
                />
    }

    addTooltips = (tags) => {
        const tooltips = {};
        if(!tags) return tooltips;

        const tagsWithTooltips = tags;

        if(this.props.isCurrentUser) {
            tagsWithTooltips.forEach(tag => {
                tooltips[tag.tagId] = strings.tags_cant_unassign_current_user;
            });
            return tooltips;
        }
        
        tagsWithTooltips.forEach(tag => {
            if(this.props.disableGuestTags && !tag.canEdit){
                tooltips[tag.tagId] = strings.tags_you_cant_unassign_with_guest_access;
                return;
            }

            const tagIsSelected = this.props.selectedTagsIds.includes(tag.tagId);

            if(this.props.disableRootTag ){
                if((!tag.parentTagId || tag.isRootTag) && tagIsSelected){
                    tooltips[tag.tagId] = strings.tags_cant_unassign_ravens_from_root_tag;
                    return;
                }
            }

            if(this.props.disableInheritedTags && this.props.inheritedTagsIds){
                if(this.props.inheritedTagsIds.includes(tag.tagId) && tagIsSelected){
                    tooltips[tag.tagId] = strings.tags_cant_edit_inherited_user;
                    return;
                }
            }

        });

        return tooltips;
    }

    // RAV-6242
    // The onChange function will ignore the request if the change is redundant.
    // In particular, this patch attemps to avoid re-selecting a 'SYSTEM` tag while editing/adding a new tag.
    // This patch appears to be necessary in order to avoid updating a New Tag to have a `SYSTEM` type.
    // Search code base for "RAV-6242" to find two other related changes.
    // This patch could be made more specific by searching this.props.tags to determine if the selected tag is of type `SYSTEM`.
    onChange = (selectedTagsIds) => {
        // check if the requested "change" is redundant
        if (selectedTagsIds.length === this.props.selectedTagsIds.length) {
            // compare the two arrays
            const diff = selectedTagsIds.filter(tagId => !this.props.selectedTagsIds.includes(tagId));
            if (diff.length === 0) {
                // ignore the request
                console.warn("RAV-6242 TagsTreeView redundant onChange requested (no change).");
                return; 
            }
        }
        // continue with the change
        if(this.props.onChange) this.props.onChange(selectedTagsIds);
    }

    render(){
        const readOnlyTagsIds = this.getReadonlyTagsIds();
        let tooltips = this.props.showTooltips ? this.addTooltips(this.props.tags) : {};

        return (
        <>
            <TreeView
                nodes={this.props.tags} 
                tooltips={tooltips}
                expandedKeys={this.props.expandedTagsIds}
                onExpandedKeysChange={this.props.onExpandedTagsChange}
                selectedKeys={this.props.selectedTagsIds}                
                onKeywordFilterChange={this.props.onKeywordFilterChange}
                keywordFilterValue={this.props.keywordFilterValue}
                customFilterValue={this.state.selectedTagTypes.length > 0 ? this.state.selectedTagTypes : null}
                showConfrimOnDeselect={this.props.showConfrimOnDeselect}
                multipleSelection={this.props.multipleSelection}
                onChange={this.onChange}
                fields={{key: 'tagId', parentKey: 'parentTagId', label: 'name', childNodes: 'childTags', ancestors: 'ancestors', customFilter: 'type'}} 
                customFilter={this.getCustomFilter()}
                customFilterHandler={(tag) => {
                        if(this.state.selectedTagTypes.length === 0) return true;
                        return this.state.selectedTagTypes.includes(tag.type);
                    }
                }
                confirmMessage={this.createConfirmMessage}
                compact={this.props.compact}
                readonly={this.props.isCurrentUser}
                readonlyKeys={readOnlyTagsIds}
                showTooltips={this.props.showTooltips}
                cascadeSelection={this.props.cascadeSelection}
            />
        </>
        )
    }
}